import angular from "angular";
import uiRouter from "angular-ui-router";
import accountprofileComponent from "./accountprofile.component";

let accountprofileModule = angular
  .module("accountprofile", [uiRouter])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider
      .state("accountprofile", {
        url: "/account-profile",
        template: "<accountprofile></accountprofile>",
        title: "Account Profile",
        params: {
          validation: null,
          payment: null,
          event_for_back: null,
        },
      })
      .state("accountprofile-company-users", {
        url: "/account-profile/:companyId/company-users",
        template: "<accountprofile></accountprofile>",
        title: "Account Users",
      })
      .state("accountprofile-payment-information", {
        url: "/account-profile/:companyId/payment-information?eid",
        template: "<accountprofile></accountprofile>",
        title: "Account Billing",
        params: {
          validation: null,
          payment: null,
          event_for_back: null,
          event_for_back_payment: null,
        },
      })
      .state("accountprofile-settings", {
        url: "/account-profile/:companyId/settings",
        template: "<accountprofile></accountprofile>",
        title: "Admin Tools",
      })
      .state("accountprofile-subscription-plans", {
        url: "/account-profile/:companyId/subscription-plans",
        template: "<accountprofile></accountprofile>",
        title: "Subscription Plans",
      })
      .state("accountprofile-payment-history", {
        url: "/account-profile/:companyId/payment-history",
        template: "<accountprofile></accountprofile>",
        title: "Payment History",
      })
      .state("accountprofile-notification-center", {
        url: "/account-profile/:companyId/notification-center",
        template: "<accountprofile></accountprofile>",
        title: "Notification Center",
      });
  })

  .component("accountprofile", accountprofileComponent);

export default accountprofileModule;



// WEBPACK FOOTER //
// ./client/app/components/accountprofile/accountprofile.js